// LoadingPage.jsx (MODIFIED to eliminate redirect delay)

import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./LoadingPage.css";

// Accept the new prop: isContentLoader
function LoadingPage({ message: propMessage, isContentLoader }) {
  const navigate = useNavigate();
  const location = useLocation();

  const { message: stateMessage, redirectTo } = location.state || {};
  const defaultRedirect = "/";

  // Determine the message to display
  const message = propMessage || stateMessage || "Checking session status...";

  useEffect(() => {
    // 💡 CRITICAL FIX: If we have a final destination path from the backend (redirectTo)
    // AND we are not a content loader, navigate immediately (0ms delay).
    if (redirectTo && !isContentLoader) {
      // 🚨 FIX: Navigate instantly to prevent the flash.
      // The component will only show for a fraction of a second while the
      // browser processes the redirect.
      navigate(redirectTo || defaultRedirect, { replace: true });

      // Since the navigation is instant, we don't need a timeout or a cleanup function.
      return;
    }

    // Fallback: If no explicit 'redirectTo' is present but it's used as a route
    // and not a content loader, you might put a delayed fallback redirect here
    // (but the core login path requires instant navigation).
    if (!redirectTo && !isContentLoader) {
      // This block handles cases like a user manually navigating to /loading.
      // Since the original code had a timer, we'll keep a *short* one here for safety
      // if the redirectTo state was somehow missing, but we'll reduce it significantly.
      const safetyTimer = setTimeout(() => {
        navigate(defaultRedirect, { replace: true });
      }, 50); // A minimal safety delay
      return () => clearTimeout(safetyTimer);
    }
  }, [navigate, redirectTo, defaultRedirect, isContentLoader]);

  // Use a different class based on where it's used
  const containerClass = isContentLoader
    ? "content-spinner-wrapper" // A new class for local/content-only use
    : "loading-page-container"; // Original full-screen class

  return (
    <div className={containerClass}>
      <div className="loading-spinner-placeholder">
        <div className="spinner"></div>
      </div>
      <p className="loading-message">{message}</p>
    </div>
  );
}

export default LoadingPage;
